/** Per sink, how a ticket's announcements went: one chip with its worst delivery (failed, then
 *  pending, then skipped, else sent), the counts in the tooltip. */
import { Chip, Stack, Tooltip, Typography } from '@mui/material';

import {
  deliveryStatusColor,
  deliveryStatusLabel,
  type SupportTicketSinkStatus,
} from '@/api/supportTickets';

export function SinkChips({ sinks }: { sinks: SupportTicketSinkStatus[] }) {
  if (!sinks.length) {
    return (
      <Typography variant="body2" component="span" color="text.secondary">
        None
      </Typography>
    );
  }
  return (
    <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
      {sinks.map((s) => (
        <Tooltip
          key={s.sink}
          describeChild
          title={`${s.deliveries} deliveries: ${s.sent} sent, ${s.pending} pending, ${s.skipped} skipped, ${s.failed} failed`}
        >
          <Chip
            size="small"
            variant="outlined"
            color={deliveryStatusColor(s.status)}
            label={`${s.sink}: ${deliveryStatusLabel(s.status).toLowerCase()}`}
          />
        </Tooltip>
      ))}
    </Stack>
  );
}
